import { useTranslation } from "react-i18next";
import { Minus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { minOrder, normalizeQuantity, packSize } from "@/lib/product";

/**
 * Aantal-stepper die per verpakking springt (besteleenheid uit het CRM) en
 * nooit onder de minimale afname komt.
 */
export const QuantityStepper = ({
  product,
  value,
  onChange,
  disabled = false,
  inputId = "quantity",
  testIdPrefix = "quantity",
}) => {
  const { t } = useTranslation();
  const stap = packSize(product) || 1;
  const minimum = normalizeQuantity(product, minOrder(product) || stap);
  const huidig = Number(String(value).replace(",", ".")) || 0;

  const zet = (nieuw) => onChange(String(normalizeQuantity(product, Math.max(minimum, nieuw))));

  return (
    <div className="flex items-stretch gap-2">
      <div className="flex items-stretch overflow-hidden rounded-md border">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-10 w-10 rounded-none border-r"
          onClick={() => zet(huidig - stap)}
          disabled={disabled || huidig <= minimum}
          aria-label={t("product.decrease", { stap })}
          data-testid={`${testIdPrefix}-decrease`}
        >
          <Minus className="h-4 w-4" aria-hidden="true" />
        </Button>
        <Input
          id={inputId}
          type="text"
          inputMode="numeric"
          readOnly
          tabIndex={-1}
          value={value}
          aria-live="polite"
          className="h-10 w-16 cursor-default rounded-none border-0 bg-transparent text-center tabular-nums focus-visible:ring-0"
          disabled={disabled}
          data-testid={`${testIdPrefix}-input`}
        />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-10 w-10 rounded-none border-l"
          onClick={() => zet(huidig + stap)}
          disabled={disabled}
          aria-label={t("product.increase", { stap })}
          data-testid={`${testIdPrefix}-increase`}
        >
          <Plus className="h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
};
